<template>
  <div class="wb-page">

    <!-- Hero -->
    <div class="wb-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-cast-education</v-icon>
        </v-avatar>
        <div>
          <div class="wb-hero__title">Webinars del Programa</div>
          <div class="wb-hero__sub">{{ programa_name }}</div>
        </div>
      </div>
      <v-btn small dark text @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <div class="wb-body">

      <!-- Toolbar -->
      <v-card outlined class="wb-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex align-center" style="gap:10px;">
          <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ desserts.length }} webinar{{ desserts.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-text-field
            v-model="search"
            placeholder="Buscar..."
            prepend-inner-icon="mdi-magnify"
            dense outlined hide-details clearable
            style="max-width:260px;"
          />
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="wb-table-card">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :search="search"
          hide-default-footer
          disable-pagination
          dense
          class="wb-table"
          no-data-text="Sin webinars registrados."
          loading-text="Cargando..."
        >
          <template v-slot:[`item.carga_horaria`]="{ item }">
            {{ item.carga_horaria }} hrs.
          </template>

          <template v-slot:[`item.fecha_webinar`]="{ item }">
            {{ parseDate(item.fecha_webinar) }}
          </template>

          <template v-slot:[`item.fecha_inicio_matriculacion`]="{ item }">
            {{ parseDate(item.fecha_inicio_matriculacion) }}
          </template>

          <template v-slot:[`item.fecha_fin_matriculacion`]="{ item }">
            {{ parseDate(item.fecha_fin_matriculacion) }}
          </template>

          <template v-slot:[`item.opt`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="teal darken-1" v-bind="attrs" v-on="on" @click="openlink(item)">
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>Abrir formulario de registro</span>
            </v-tooltip>
          </template>

        </v-data-table>
      </v-card>

    </div>
  </div>
</template>

<script>
import { getwebinars } from './getWebinars';
import xaxios from '@/xaxios';

export default {
  data: () => ({
    loading: false,
    search: '',
    programa_id: -1,
    programa_name: '',
    desserts: [],
    headers: [
      { text: 'Webinar',            value: 'nombre' },
      { text: 'Carga horaria',      value: 'carga_horaria',             width: 120 },
      { text: 'Participantes',      value: 'registrados',               width: 120 },
      { text: 'Ciudad',             value: 'ciudad_emision',            width: 120 },
      { text: 'Fecha webinar',      value: 'fecha_webinar',             width: 150 },
      { text: 'Inicio registros',   value: 'fecha_inicio_matriculacion', width: 140 },
      { text: 'Fin registros',      value: 'fecha_fin_matriculacion',   width: 140 },
      { text: '',                   value: 'opt',                       width: 60, sortable: false },
    ],
  }),
  methods: {
    async getWebinars() {
      this.loading = true;
      this.desserts = [];
      let url = process.env.VUE_APP_WEBINARS_APP;
      let datos = { query: getwebinars(this.programa_id), variables: {} };
      let config = { method: 'post', url, headers: { 'Content-Type': 'application/json' }, data: datos };
      let res = await xaxios.request(config).then(({ data }) => data).catch((e) => e);
      if (res && res.data) {
        let ws = res.data.webinarsByPrograma;
        if (ws.length == 0) {
          this.$root.$notify.show('Este programa no tiene webinars', { color: 'red', x: 'right' });
        } else {
          this.desserts = ws;
        }
      }
      this.loading = false;
    },
    parseDate(f, show_hours = true) {
      if (!f) return '-';
      if (!f.includes('T')) f += 'T::';
      const partes = f.split('T');
      const fs1 = partes[0].split('-');
      const fs2 = partes[1].split(':');
      if (show_hours) return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
      return `${fs1[2]}/${fs1[1]}/${fs1[0]}`;
    },
    openlink(item) {
      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      const host = window.location.href + '';
      let cifrado = btoa(item.id);
      let xurl = `/for/webinar/${cifrado}`;
      const datauser = this.$store.state.DATA_USER;
      xurl += `?shared=${datauser.id}`;
      let url = '';
      if (host.includes('webdev.')) {
        window.open('/webinars/#' + xurl);
      } else {
        if (unidad == 10)     url = 'https://dbussinesschool.com/webinars/#' + xurl;
        else if (unidad == 6) url = 'https://cybercorp.com.bo/webinars/#' + xurl;
        else                  url = 'https://esam.edu.bo/webinars/#' + xurl;
        window.open(url);
      }
    },
  },
  mounted() {
    this.programa_id = this.$route.query.programaid;
    this.programa_name = this.$route.query.name;
    this.getWebinars();
  },
};
</script>

<style scoped>
.wb-page { min-height: 100vh; background: #f5f7fa; }

.wb-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.wb-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.wb-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.wb-body { padding: 20px 24px; }

.wb-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.wb-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.wb-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.wb-table >>> tbody tr:hover { background: #f0f4ff !important; }
.wb-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
